import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CheckoutGuard {
  constructor(
    private location: Location,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentNavigation = this.router.getCurrentNavigation();

    if (
      !currentNavigation?.previousNavigation ||
      currentNavigation?.trigger !== 'imperative'
    ) {
      this.location.back();
      return false;
    }

    return true;
  }
}
